import React from "react"
import { container, IContainerProps } from "./container"
import { UserSetting } from "./setting"

type IProps = IContainerProps

const Component = (props: IProps) => {
  return <UserSetting {...props} currentUser={props.currentUser!} />
}

export default container(Component)
